import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "axios";

export default axios.create({
  baseURL: baseUrl,
  // headers: {
  //   'Content-Type': 'application/json',
  //   Authorization: `Bearer ${localStorage.getItem('Token')}`,
  // },
});
